
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcElevatedCardRadio as ObcElevatedCardRadioElement} from '@oicl/openbridge-webcomponents/dist/components/elevated-card-radio/elevated-card-radio.js';
 
 
 

 
 export const ObcElevatedCardRadio = createComponent({
   react: React,
   tagName: 'obc-elevated-card-radio',
   elementClass: ObcElevatedCardRadioElement,
   events: {
     
     onChange: 'change' as EventName<CustomEvent<unknown>>,
   }
  });
 
 